import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalHeaderTableComponent } from '../../modals/modal-header-table/modal-header-table.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-table-general',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTooltip,
  ],
  templateUrl: './table-general.component.html',
  styleUrl: './table-general.component.scss',
})
export class TableGeneralComponent {
  @Output() idEmitter = new EventEmitter<number>();
  @Output() elementEmitter = new EventEmitter<any>();
  @Output() endElementEmitter = new EventEmitter<{ button: any; item?: number }>();
  @Input() headers: { value: string; description: string }[] = [];
  @Input() dataSource = new MatTableDataSource<any>([]);
  @Input() isLoading = false;
  @Input() activeColums: { value: string; isBoolean: boolean }[] = [];
  @Input() buttonEvent = true;
  @Input() checkEvent = false;
  @Input() isSticky = false;
  @Input() isStickyEnd = false;
  @Input() menuButton: { icon: string; key: string; text: string }[] = [];
  public isMobile = false;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.checkMobile.bind(this));
  }

  private checkMobile(): void {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
  }

  public emitterButton(id: number, element: any): void {
    this.idEmitter.emit(id);
    this.elementEmitter.emit(element);
  }

  public endEmitter(button: any, item?: number): void {
    this.endElementEmitter.emit({ button, item });
  }

  public updateElement(item: any, header: string, event: boolean) {
    item[header] = event;
  }

  public isBoolean(value: unknown): boolean {
    return typeof value === 'boolean';
  }

  get headerKeys(): string[] {
    return this.headers?.map((h) => h.value) ?? [];
  }
}
